import { RootState } from 'store';

import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { STATIONS_STATE } from 'entities/stations';

import { binarySearch } from 'common/utils';

export const useRouteStationsWithPrices = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].routesStationsWithPrices.data)
);

export const useGetRouteStationsWithPrices = () => {
  const routeStationsWithPrices = useRouteStationsWithPrices();

  const getRouteStationsWithPrices = useCallback((stationCode: string) => (
    binarySearch({ key: 'stationCode', value: stationCode }, routeStationsWithPrices || [])
  ), [routeStationsWithPrices]);

  return getRouteStationsWithPrices;
};
